var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMarkEncircled = function SvgQuestionMarkEncircled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0Zm-.417 15.833a1.25 1.25 0 1 1 .001-2.5 1.25 1.25 0 0 1 0 2.5Zm3.593-7.394c-.258.413-.747.876-1.469 1.391-1.167.863-1.135 1.055-1.135 1.837H8.524c0-.611-.013-1.08.317-1.651.21-.366.597-.755 1.159-1.167.674-.482 1.33-.946 1.33-1.754 0-.757-.65-1.027-1.407-1.027-.772 0-1.653.252-2.642.757l-.843-1.692c1.798-1.007 4.635-1.463 6.185-.2 1.139.927 1.145 2.558.553 3.506Z"
  })));
};
export default SvgQuestionMarkEncircled;